import { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // ✅ Import Link

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
      let fromTop = window.scrollY + 100;
      document.querySelectorAll("section, header").forEach((sec) => {
        if (
          sec.offsetTop <= fromTop &&
          sec.offsetTop + sec.offsetHeight > fromTop
        ) {
          setActive("#" + sec.id);
        }
      });
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={scrolled ? "scrolled" : ""} id="navbar">
      <div className="logo">
        {/* ✅ Clicking this will take user to homepage (/) */}
        <Link
          to="/"
          style={{ fontWeight: 600, color: "#fff", textDecoration: "none" }}
        >
          Mardacannes
        </Link>
      </div>
      <div className="links">
        {[
          "overview",
          "villas",
          "features",
          "services",
          "innovations",
          "roadmap",
          "location",
          "contact",
        ].map((link) => (
          <a
            key={link}
            href={`#${link}`}
            className={active === `#${link}` ? "active" : ""}
          >
            {link.charAt(0).toUpperCase() + link.slice(1)}
          </a>
        ))}
      </div>
    </nav>
  );
}
